declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
    clarity?: (...args: unknown[]) => void;
    mixpanel?: {
      track: (event: string, properties?: Record<string, unknown>) => void;
      identify: (id: string) => void;
      people: { set: (properties: Record<string, unknown>) => void };
    };
  }
}

export function trackEvent(eventName: string, params?: Record<string, unknown>) {
  window.dataLayer?.push({ event: eventName, ...params });
  window.mixpanel?.track(eventName, params);
}

export function tagClaritySession(key: string, value: string) {
  if (typeof window.clarity === 'function') {
    window.clarity('set', key, value);
  }
}

export function identifyUser(id: number, email: string, name: string | null) {
  window.mixpanel?.identify(String(id));
  window.mixpanel?.people.set({ $email: email, $name: name });
}

export function markFunnelStage(stage: string, event: string, payload?: Record<string, unknown>) {
  trackEvent(event, payload);
  tagClaritySession('funnel_stage', stage);
}
